import { api } from "@/redux/api";

import { RequestPaginationParams } from "@/types/request-params";
import { ReviewStatus, ReviewStatusSchema } from "@/schemas/review-status";

import {
	CreateMessageTemplate,
	MessageTemplate,
	MessageTemplateResponse,
	MessageTemplateResponseSchema,
	MessageTemplateSchema,
} from "../../pages/Messages/schema/message-template.schema";

export const messageTemplateApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getTemplatesReviewStatus: builder.query<ReviewStatus, void>({
			query: () => ({
				url: "message-template/review-status",
				responseSchema: ReviewStatusSchema,
			}),
			providesTags: ["TemplatesReviewStatus"],
		}),
		markTemplatesReviewed: builder.mutation<ReviewStatus, void>({
			query: () => ({
				url: "message-template/mark-reviewed",
				method: "POST",
				responseSchema: ReviewStatusSchema,
			}),
			invalidatesTags: ["TemplatesReviewStatus"],
		}),
		getMessageTemplates: builder.query<MessageTemplateResponse, RequestPaginationParams>({
			query: ({ sorting, ...params }) => ({
				url: "message-template",
				params: {
					...(params && { ...params }),
					...(sorting && { ...sorting }),
				},
				responseSchema: MessageTemplateResponseSchema,
			}),
			providesTags: (result) =>
				result?.data.map((item) => ({ type: "MessageTemplate", id: item.id })) || [],
		}),
		getMessageTemplate: builder.query<MessageTemplate, number>({
			query: (id) => ({
				url: `message-template/${id}`,
				responseSchema: MessageTemplateSchema,
			}),
			providesTags: (result) => [{ type: "MessageTemplate", id: result?.id }],
		}),
		createMessageTemplate: builder.mutation<MessageTemplate, CreateMessageTemplate>({
			query: (body) => ({
				url: `message-template`,
				method: "POST",
				body,
				responseSchema: MessageTemplateSchema,
			}),
			invalidatesTags: (result) => [{ type: "MessageTemplate", id: result?.id }],
		}),
		updateMessageTemplate: builder.mutation<MessageTemplate, Partial<MessageTemplate>>({
			query: ({ id, ...body }) => ({
				url: `message-template/${id}`,
				method: "PATCH",
				body,
				responseSchema: MessageTemplateSchema,
			}),
			invalidatesTags: (result) => [{ type: "MessageTemplate", id: result?.id }],
		}),
		deleteMessageTemplate: builder.mutation<{ id: number }, number>({
			query: (id) => ({
				url: `message-template/${id}`,
				method: "DELETE",
			}),
			invalidatesTags: (result) => [{ type: "MessageTemplate", id: result?.id }],
		}),
	}),
});

export const {
	useGetMessageTemplatesQuery,
	useGetMessageTemplateQuery,
	useGetTemplatesReviewStatusQuery,
	useMarkTemplatesReviewedMutation,
	useCreateMessageTemplateMutation,
	useUpdateMessageTemplateMutation,
	useDeleteMessageTemplateMutation,
} = messageTemplateApi;
export const messageTemplateApiReducer = messageTemplateApi.reducer;
export const messageTemplateApiMiddleware = messageTemplateApi.middleware;
